var en_us = {
    values: {
        'must not be empty': 'must not be empty',
        'Apply': 'Apply',
        'Add': 'Add',
        'add line': 'Add line',
        'copy': 'copy',
        'optional': 'optional',
        'Hour': 'Hour',
        'Choose': 'Choose',
        'Save': 'Save',
        'Cancel': 'Cancel',
        'Not found file type': 'Not found file type',
        'Edit query (for advanced users)': 'Edit query (for advanced users)',
        'Edit query': 'Edit query',
        'EXPRESSION (Pipes)': 'EXPRESSION (Pipes)',
        'RESTORE DEFAULT QUERY': 'RESTORE DEFAULT QUERY',
        'You are already using the default query.': 'You are already using the default query.',
        'Editing this query may cause chart malfunction.': 'Editing this query may cause chart malfunction.',
        'Help with language.': 'Help with language.',
        Sections: 'Sections',
        "Don't import": "Don't import",
        'Casing string': 'Casing string',
        'Drill string': 'Drill string',
        'TUBULAR': 'TUBULAR',
        'Select a option': 'SELECT A OPTION',
        'Phase': 'Phase',
        'Run name': 'Run name',

    }
}

module.exports = en_us
